module.exports = __webpack_public_path__ + "img/4.1.6ef11b88.png";